import React from "react";
const Footer = () => {
  return (
    <footer className="bg-footer text-gray-800 p-0 m-0 py-8 block">
      <div className="max-w-7xl mx-auto px-4 p-0 m-0">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Brand Section */}
          <div>
            <h4 className="font-bold text-2xl text-red-500">Kalka Capital</h4>
            <p className="mt-2 text-white">
              Connecting you to the best solutions.
            </p>
          </div>

          {/* Quick Links Section */}
          <div>
            <h4 className="font-bold text-xl text-red-500">Quick Links</h4>
            <div className=" md:flex gap-20">
              <ul className="mt-2 space-y-1">
                <li>
                  <a href="/" className="text-white hover:text-red-600 hover:border-b">
                    Home
                  </a>
                </li>
                <li>
                  <a href="/about" className="text-white hover:text-red-600 hover:border-b">
                    About
                  </a>
                </li>
                <li>
                  <a href="/tools" className="text-white hover:text-red-600 hover:border-b">
                    Calculators
                  </a>
                </li>
                <li>
                  <a href="/contact" className="text-white hover:text-red-600 hover:border-b">
                    Contact
                  </a>
                </li>
              </ul>
              <ul className="mt-2 space-y-1">
                <li>
                  <a href="/loan" className="text-white hover:text-red-600 hover:border-b">
                    Various Loan Options
                  </a>
                </li>
                <li>
                  <a
                    href="/construction"
                    className="text-white hover:text-red-600 hover:border-b"
                  >
                    Construction
                  </a>
                </li>
                <li>
                  <a
                    href="/investment"
                    className="text-white hover:text-red-600 hover:border-b"
                  >
                    Insurance
                  </a>
                </li>
                <li>
                  <a href="/business" className="text-white hover:text-red-600 hover:border-b">
                    Investment & Consulting
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact Us Section */}
          <div>
            <h4 className="font-bold text-xl text-red-500">Contact Us</h4>
            <p className="mt-2 text-white">Email: kalkacapital@gmail.com</p>
            <p className="text-white">Phone: +91 7566611125</p>
          </div>
        </div>

        {/* Footer Bottom Section */}
        <div className="mt-8 text-center text-gray-300 text-[12px] font-semibold">
          <p>
            &copy; {new Date().getFullYear()} Kalka Capital Pvt Ltd. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
